var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNfts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3778_13087)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#004988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.25 50C43.5761 50 44.8479 49.4732 45.7855 48.5355C46.7232 47.5979 47.25 46.3261 47.25 45C47.25 43.6739 46.7232 42.4021 45.7855 41.4645C44.8479 40.5268 43.5761 40 42.25 40C40.9239 40 39.6521 40.5268 38.7145 41.4645C37.7768 42.4021 37.25 43.6739 37.25 45C37.25 46.3261 37.7768 47.5979 38.7145 48.5355C39.6521 49.4732 40.9239 50 42.25 50ZM49.75 22.5L73.5 36.25V63.75L49.75 77.5L26 63.75V36.25L49.75 22.5ZM31 39.1325V60.8675L36.93 64.3L57.1125 49.5L68.5 56.335V39.135L49.75 28.275L31 39.1325Z",
    fill: "#004988"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3778_13087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfts);
export default __webpack_public_path__ + "static/media/nfts.d9289b6f2848021b798a535b7c076f36.svg";
export { ForwardRef as ReactComponent };